/* v8 ignore start */
import {useEffect} from "react";

import {AppConfiguration} from "@/appConfiguration";
import {useAppDispatch} from "@/store";
import {tokenReceived} from "@/store/slices/authSlice";

function TokenReceiver() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    window.parent.postMessage(JSON.stringify({type: "READY"}), AppConfiguration.iframeParentUrl);

    const handleMessage = (event: MessageEvent) => {
      try {
        const message = JSON.parse(event.data);

        if (message.type === "AUTH" && message.content.token) {
          dispatch(tokenReceived(message.content.token));
        }
      } catch {
        // ignore
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [dispatch]);

  return null;
}

export default TokenReceiver;
/* v8 ignore stop */
